export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11645.ffc0c9b8.jpg";